import React, { useEffect, useState, useRef } from 'react';
import { Link, Redirect, useHistory, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import { API } from 'aws-amplify';
import {AmplifyS3Image} from "@aws-amplify/ui-react";

import Image from '../images/user-avatar-80.png';
import AuthImage from '../images/auth-image.jpg';
import SignInImage from '../images/sign-in.jpg';
import SignInImage2 from '../images/sign-in.gif';
import EmPushyLogo from '../images/empushy_logo_black.png';
import AuthDecoration from '../images/auth-decoration.png';
import jBox from 'jbox'
import 'jbox/dist/jBox.all.css';

import { getApp } from "firebase/app"
import { getMessaging, getToken, onMessage } from "firebase/messaging";

function SubProfile() {

  const { id } = useParams()
  const messaging = getMessaging(getApp('push'));

  const [currentToken, setCurrentToken] = useState(null)
  const [alias, setAlias] = useState('')
  const [description, setDescription] = useState('')
  const [permission, setPermission] = useState(false)
  const [subscribed, setSubscribed] = useState(null)
  const subscribeRef = useRef()
  const unsubscribeRef = useRef()

  useEffect(() => {
    if(Notification.permission === 'denied')
      permissionDenied()
    else if(Notification.permission === 'default'){
      askForPermission()
    }
    else if(Notification.permission === 'granted'){
      permissionGranted()
    }
  }, []);

  function askForPermission(){
    var confirmPermissions = new jBox('Confirm', {
      title: 'Notification Permission',
      content: 'EmPushy requires notification permission to allow you to subscribe to your favorite people.'+
        ' You can revoke this permission at any time.',
      confirmButton: 'Grant Permission',
      cancelButton: 'Revoke Permission',
      animation: {open: 'tada', close: 'flip'},
      confirm: permissionGranted,
      cancel: permissionRevoked
    });
    confirmPermissions.open()
  }

  function permissionGranted(){
    setPermission(true)
    navigator.serviceWorker.register('/firebase-messaging-sw.js', {scope: '/subprofile/'+id+'.html'})
      .then(function(swReg) {
        getToken(messaging, { serviceWorkerRegistration: swReg,
          vapidKey: 'BIDnqPmlOdUFObQ8KQRtfcpQmVa5DTUChq5iJUdwdEYNxzJiCfIVeF6rfpdP3wDfD3PLlRFhc50BfKnm4XZ8JcQ' }).then((currentToken) => {
          if (currentToken) {
            setCurrentToken(currentToken)
            fetchProfile()
            checkSubscription(currentToken)

            onMessage(messaging, (payload) => {
              console.log('Message received. ', payload);
              // ...
            });

          } else {
            askForPermission()
          }
        }).catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
        });
      }).catch(function(error) {
      console.error('Service Worker Error', error);
    });
  }

  function permissionRevoked(){
    new jBox('Notice', {content: 'You won\'t be able to subscribe unless you grant permission!',
      color: 'blue', position: {x: 'center', y: 20}});
  }

  /* ToDo: add image demonstrating how to enable permissions after denied! */
  function permissionDenied(){
    setPermission(false)
    var confirmPermissions = new jBox('Confirm', {
      title: 'Notification Permission',
      content: 'You won\'t be able to subscribe to your favorite people unless you grant Notification permissions.' +
        ' You can grant permission by clicking the small 🛈️ or 🔒 in the address bar and enabling the button beside "Notifications".' +
        'Then reload the page and you\'re all set!',
      confirmButton: 'Okay',
      cancelButton: 'Not right now',
      animation: {open: 'tada', close: 'flip'},
      closeOnConfirm: true,
      confirm: function(){return}
    });
    confirmPermissions.open()
  }

  function fetchProfile(){
    /* send lambda request to get public profile details using id */
    const apiName = 'DashboardAPI'; // replace this with your api name.
    const path = '/web-push/public-profile'; //replace this with the path you have configured on your API
    const myInit = {
      queryStringParameters: {
        id: id
      }
    };
    API
      .get(apiName, path, myInit)
      .then(response => {
        if('alias' in response){
          setAlias(response['alias'])
          setDescription(response['description'])
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  function checkSubscription(token){
    if(token!=null){
      /* send the token to lambda with id which creates and adds subscriber to clientUser */
      const apiName = 'DashboardAPI'; // replace this with your api name.
      const path = '/web-push/manage-sub'; //replace this with the path you have configured on your API
      const myInit = {
        queryStringParameters: {
          id: id,
          token: token,
          task: 'getsub'
        }
      };
      API
        .get(apiName, path, myInit)
        .then(response => {
          if(response['subscribed']){
            setSubscribed(true)
          }
          else{
            setSubscribed(false)
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
    }
    else{
      askForPermission()
    }
  }

  function subscribe(){
    if(currentToken!=null){
      subscribeRef.current.setAttribute("disabled", true)
      /* send the token to lambda with id which creates and adds subscriber to clientUser */
      const apiName = 'DashboardAPI'; // replace this with your api name.
      const path = '/web-push/manage-sub'; //replace this with the path you have configured on your API
      const myInit = {
        queryStringParameters: {
          id: id,
          token: currentToken,
          task: 'sub'
        }
      };
      API
        .get(apiName, path, myInit)
        .then(response => {
          subscribeRef.current.removeAttribute('disabled')
          if(response['subscribed']){
            setSubscribed(true)
            new jBox('Notice', {content: 'Subscribed', color: 'green', position: {x: 'center', y: 20}});
          }
          else{
            setSubscribed(false)
            new jBox('Notice', {content: 'Oops, we could not subscribe you.', color: 'red',
              position: {x: 'center', y: 20}});
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
    }
    else{
      askForPermission()
    }
  }

  function unsubscribe(){
    if(currentToken!=null){
      unsubscribeRef.current.setAttribute("disabled", true)
      /* send the token to lambda with id which creates and adds subscriber to clientUser */
      const apiName = 'DashboardAPI'; // replace this with your api name.
      const path = '/web-push/manage-sub'; //replace this with the path you have configured on your API
      const myInit = {
        queryStringParameters: {
          id: id,
          token: currentToken,
          task: 'unsub'
        }
      };
      API
        .get(apiName, path, myInit)
        .then(response => {
          unsubscribeRef.current.removeAttribute('disabled')
          if(response['unsubscribed']){
            setSubscribed(false)
            new jBox('Notice', {content: 'Successfully unsubscribed.', color: 'green', position: {x: 'center', y: 20}});
          }
          else{
            setSubscribed(true)
            new jBox('Notice', {content: 'Oops, something went wrong. Try again later.', color: 'red',
              position: {x: 'center', y: 20}});
          }
        })
        .catch(error => {
          console.log('Error executing request.')
          console.log(error)
        });
    }
  }

  return (
    <main className="bg-yellow-300 overflow-hidden max-h-screen">
      {/* Page Title */}
      <Helmet>
        <title>EmPushy Push</title>
      </Helmet>

      <div className="relative md:flex">

        {/* Content */}
        <div className="md:w-1/2">
          <div className="max-w-sm mx-auto min-h-screen flex flex-col justify-center px-4 py-8">

            <div className="w-full max-h-screen items-center">
              <div className="w-full content-center mb-4">
                <img className="m-auto" src={EmPushyLogo} width="300" height="300" viewBox="0 0 250 250" alt="Logo" />
              </div>
              <div className="flex-grow text-center">
                {/* Picture */}
                <section>
                  <div className="flex items-center mb-4">
                    <div className="m-auto">
                      {/*<img className="w-20 h-20 rounded-full" src={Image} width="80" height="80" alt="User upload" />*/}
                      <AmplifyS3Image className="w-20 h-20 rounded-full" width="80" height="80" alt={"Upload a Profile Image"}
                                      imgKey={'webPushProfileImages/'+id} level={"public"}/>
                    </div>
                  </div>
                </section>
                <section>
                  <h2 className="text-xl leading-snug text-gray-800 font-bold mb-1">{alias}</h2>
                  <div className="text-base text-gray-800">{description}</div>
                </section>
                {!permission?<button className="my-4 btn bg-green-500 hover:bg-green-600
                 text-white m-auto disabled:opacity-50" onClick={askForPermission}>Activate</button>:''}
                {subscribed===null?'':!subscribed?<button className="my-4 btn bg-green-500 hover:bg-green-600
                 text-white m-auto disabled:opacity-50" onClick={subscribe} ref={subscribeRef}>Subscribe</button>:
                  <button className="my-4 btn bg-red-500 hover:bg-red-600 text-white m-auto disabled:opacity-50"
                  onClick={unsubscribe} ref={unsubscribeRef}>Unsubscribe</button>}

              </div>

            </div>

          </div>
        </div>

        {/* Image */}
        <div className="hidden md:block absolute top-0 bottom-0 right-0 md:w-1/2" aria-hidden="true">
          {/*<img className="object-cover object-center w-full h-full" src={SignInImage} width="760" height="760" alt="Authentication" />*/}
          <img className="object-cover object-center w-full h-full" src={SignInImage2} width="500" height="500" alt="Authentication" />
          <img className="absolute top-1/4 left-0 transform -translate-x-1/2 ml-1" src={AuthDecoration} width="218" height="224" alt="Authentication decoration" />
        </div>

      </div>

    </main>
  );
}

export default SubProfile;